import React, { useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { getAccessTokenHeader } from "../../api/helper/getAccessTokenHeader";
import { getBackend } from "../../utils/getBackend";
import { authProviders } from "./authConfig";

let called = false;

export function AuthCallback() {
  const { provider } = useParams<{ provider: string }>();
  const params = new URLSearchParams(window.location.search);

  const config = provider ? authProviders[provider] : null;

  useEffect(() => {
    async function runAsync() {
      if (!config) {
        console.error(`Unknown auth provider: ${provider}`);
        return;
      }

      called = true;
      const { data } = await axios.post(
        getBackend() + config.endpoint,
        {
          ...Object.fromEntries(params.entries()),
          code: params.get("code"),
          state: params.get("state"),
        },
        { headers: await getAccessTokenHeader() }
      );

      console.log("RESPONSE SUCCESS", data);

      if (data.code === "ok") {
        window.location = "/feeds" as any;
      }
    }
    if (!called) runAsync();
  }, [config, provider]);

  if (params.get("error")) {
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="alert alert-error">
            <span>Error: {decodeURIComponent(params.get("error")!)}</span>
          </div>
          <div className="max-w-56">Please try again.</div>
        </div>
      </div>
    );
  }

  if (!config) {
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="alert alert-error">
            <span>Unknown authentication provider: {provider}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen w-full flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <span className="loading loading-spinner loading-lg text-success"></span>
        <div className="max-w-56">Login you into {config.displayName}</div>
      </div>
    </div>
  );
}
